import axios from 'axios';
import actions from '../actions/organization';

export default {
	namespaced: true,
	state: {
		organization: localStorage.getItem('organizationId') || '',
		externalId: localStorage.getItem('externalId') || '',
		organizationType: localStorage.getItem('organizationType') || '',
		organizations: [],
	},
	mutations: {
		[actions.SET_GLOBAL_ORGANIZATION]: (state, { value, externalId, orgType }) => {
			state.organization = value;
			state.externalId = externalId;
			state.organizationType = orgType;
		},
		[actions.CLEAR]: (state) => {
			state.organization = '';
			state.externalId = '';
			state.organizationType = '';
			state.organizations = [];
		},
		[actions.SET_ORGANIZATIONS]: (state, orgas) => {
			state.organizations = orgas;
		},
	},
	actions: {
		[actions.SET_GLOBAL_ORGANIZATION]: ({ commit }, { value, externalId, orgType }) => {
			commit(actions.SET_GLOBAL_ORGANIZATION, { value, externalId, orgType });
			localStorage.setItem('organizationId', value);
			localStorage.setItem('externalId', externalId);
			localStorage.setItem('organizationType', orgType);
		},
		[actions.CLEAR]: ({ commit }) => {
			commit(actions.CLEAR);
		},
		[actions.GET_BRANCHES]: async ({ rootState }, { id, userId }) => {
			let organizations = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'branches_for_master_organization' && x.templated);

				const href = link.href
					.replace('{id}', id)
					.replace('{userId}', userId);

				const response = await axios.get(href);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.GET_ORGANIZATION_ROLES]: async ({ rootState }, { id, userId }) => {
			let roles = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'organization_roles_except_existing' && x.templated);

				const href = link.href
					.replace('{id}', id)
					.replace('{userId}', userId);

				const response = await axios.get(href);

				const { data } = response;

				roles = data;
			} catch (error) {
				throw error;
			}

			return roles;
		},
		[actions.GET_ALL_ORGANIZATION_ROLES]: async ({ rootState }, { id, userId }) => {
			let roles = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'organization_roles' && x.templated);

				const href = link.href
					.replace('{id}', id)
					.replace('{userId}', userId);

				const response = await axios.get(href);

				const { data } = response;

				roles = data;
			} catch (error) {
				throw error;
			}

			return roles;
		},
		[actions.GET_MASTER_ORGANIZATIONS]: async ({ rootState }) => {
			let masterOrganizations = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'master_organizations');

				const response = await axios.get(link.href);

				const { data } = response;

				masterOrganizations = data;
			} catch (error) {
				throw error;
			}

			return masterOrganizations;
		},
		[actions.GET_ORGANIZATIONS_BY_NAME]: async ({ rootState }, searchString) => {
			let result = [];
			try {
				const link = rootState.root.links.find(x => x.rel === 'find_organizations_by_name');

				const response = await axios.get(link.href.replace('{search}', searchString));

				const { data } = response;

				result = data;
			} catch (error) {
				throw error;
			}

			return result;
		},
		[actions.GET_ORGANIZATION_BY_GUID]: async ({ rootState }, guid) => {
			let result = [];
			try {
				const link = rootState.root.links.find(x => x.rel === 'organizations_by_id');

				const response = await axios.get(link.href.replace('{id}', guid));

				const { data } = response;

				result = data;
			} catch (error) {
				throw error;
			}

			return new Array(result);
		},
		[actions.GET_ORGANIZATIONS_BY_TYPE]: async ({ rootState }, type) => {
			let result = [];
			try {
				const link = rootState.root.links.find(x => x.rel === 'organizations_by_type');

				const response = await axios.get(link.href.replace('{type}', type));

				const { data } = response;

				result = data;
			} catch (error) {
				throw error;
			}

			return result;
		},
		[actions.GET_ORGANIZATIONS_BY_TYPE_PARENT]: async ({ rootState }, { type, parent }) => {
			let result = [];
			try {
				const link = rootState.root.links.find(x => x.rel === 'organizations_by_type_and_parent');

				const response = await axios.get(link.href.replace('{type}', type).replace('{parent}', parent));

				const { data } = response;

				result = data;
			} catch (error) {
				throw error;
			}

			return result;
		},
	},
	getters: {
		HasOrganization: state => !!state.organization,
		Organization: state => state.organization,
		SelectedOrganization: state => state.organizations.find(x => x.value === state.organization) || null,
		ExternalId: state => state.externalId,
	},
};
